// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"389":"63b28","915":"0e626"}[chunkId] + ".css";
};